module.exports = __webpack_public_path__ + "img/DigiCampus Logo High-small.16d9af7c.png";